<template>
    <div class="card config-section">
        <CardHeader
            title="Configurações de Fuso Horário"
            icon="fas fa-clock"
        />

        <div class="card-body">
            <div class="section-form">
                <!-- Alert informativo -->
                <div
                    class="alert alert-info"
                    role="alert"
                >
                    <div class="alert-content d-flex gap-2">
                        <i class="fas fa-info-circle mr-2"></i>
                        <div>
                            <strong>ATENÇÃO!</strong> A quantidade de horas selecionada abaixo será
                                                      adicionada ou subtraída do <strong>Horário Padrão de
                                                                                         Brasília</strong>
                                                      ou Horário de Verão de Brasília (se ativo).
                        </div>
                    </div>
                </div>

                <div class="row">
                    <!-- Tipo de operação -->
                    <div class="col-md-6">
                        <div class="form-group">
                            <label
                                for="timezone_operation"
                                class="form-label"
                            >
                                <span class="required">*</span>
                                Tipo de operação
                            </label>
                            <select
                                id="timezone_operation"
                                class="form-control"
                                :value="value.timezone_operation"
                                @input="updateField('timezone_operation', $event.target.value)"
                            >
                                <option value="+">Adicionar Horas (+)</option>
                                <option value="-">Subtrair Horas (-)</option>
                            </select>
                        </div>
                    </div>

                    <!-- Quantidade de horas -->
                    <div class="col-md-6">
                        <div class="form-group">
                            <label
                                for="timezone_hours"
                                class="form-label"
                            >
                                <span class="required">*</span>
                                Quantidade de horas
                            </label>
                            <input
                                id="timezone_hours"
                                type="number"
                                class="form-control"
                                :value="value.timezone_hours"
                                @input="updateField('timezone_hours', $event.target.value)"
                                placeholder="Digite a quantidade de horas"
                                min="0"
                                max="24"
                            />

                            <small class="form-text text-muted">
                                Valor entre 0 e 24 horas
                            </small>
                        </div>
                    </div>
                </div>

                <!-- Preview da configuração -->
                <div class="timezone-preview">
                    <div class="preview-card">
                        <div class="preview-header">
                            <i class="fas fa-eye mr-2"></i>
                            Visualização da Configuração
                        </div>
                        <div class="preview-content">
                            <span class="preview-text">
                                O sistema irá
                                <strong class="operation-text">
                                    {{ value.timezone_operation === '+' ? 'adicionar' : 'subtrair' }}
                                </strong>
                                <strong class="hours-text">{{ value.timezone_hours || 0 }} hora(s)</strong>
                                do horário de Brasília
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CardHeader from "../../Base/CardHeader.vue";

export default {
    name: 'TimezoneConfig',
    components: {CardHeader},
    props: {
        value: {
            type: Object,
            required: true
        },
    },
    methods: {
        updateField(field, newValue) {
            this.$emit('update', field, newValue);
        }
    }
};
</script>

<style scoped>
.config-section {
    border: none;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    margin-bottom: 25px;
    overflow: hidden;
}

.alert-content i {
    margin-top: 2px;
    font-size: 16px;
}

.form-text {
    font-size: 12px;
    color: #6c757d;
    margin-top: 5px;
}

/* Select personalizado */
select.form-control {
    appearance: none;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23FE8D18' d='M6 8.825l-6-6h12z'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 12px center;
    padding-right: 35px;
}

/* Preview da configuração */
.timezone-preview {
    margin-top: 25px;
}

.preview-card {
    background: linear-gradient(135deg, #f8f9fa, #e9ecef);
    border-radius: 8px;
    overflow: hidden;
    border: 1px solid #dee2e6;
}

.preview-header {
    background: linear-gradient(135deg, #6c757d, #495057);
    color: white;
    padding: 12px 16px;
    font-weight: 600;
    font-size: 14px;
}

.preview-content {
    padding: 16px;
}

.preview-text {
    font-size: 15px;
    color: #495057;
    line-height: 1.5;
}

.operation-text {
    color: #FE8D18;
}

.hours-text {
    color: #28a745;
}

/* Responsividade */
@media (max-width: 768px) {

    .alert-content {
        flex-direction: column;
        gap: 8px;
    }

    .alert-content i {
        margin-top: 0;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Parameters/components/TimezoneConfig.vue